export enum ComponentModeEnum {
    EDIT = 'edit',
    SHOW = 'show',
}